export default __webpack_public_path__ + "static/media/OpenSans-SemiBold.83f1636b.woff";